export default __webpack_public_path__ + "static/media/vip-banner-mobile-cn.0786e632.webp";